import PropTypes from 'prop-types';

import {Box, Image, Text, useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui';

/**
 * Shared header for both Single and Stacked optional add-on layouts.
 * Renders group title, short description, and an optional thumbnail image.
 * Returns null when all three props are absent.
 *
 * @param {Object} props
 * @param {string} [props.groupTitle] - typeName / recommendationType.displayValue
 * @param {string} [props.description] - shortDescription from the first product
 * @param {string} [props.imageUrl] - thumbnail image URL (Single layout only)
 * @param {string} [props.imageAlt] - alt text for the thumbnail
 */
const OptionalAddOnHeader = ({groupTitle, description, imageUrl, imageAlt = ''}) => {
  const styles = useMultiStyleConfig('OptionalAddOns', {});

  if (!groupTitle && !description && !imageUrl) return null;

  return (
    <Box {...styles.groupHeader}>
      {imageUrl && (
        <Image
          alt={imageAlt}
          loading="lazy"
          src={imageUrl}
          {...styles.groupHeaderImage}
        />
      )}
      <Box {...styles.groupHeaderInfo}>
        {groupTitle && <Text {...styles.groupTitle}>{groupTitle}</Text>}
        {description && <Text {...styles.groupDescription}>{description}</Text>}
      </Box>
    </Box>
  );
};

OptionalAddOnHeader.displayName = 'OptionalAddOnHeader';

OptionalAddOnHeader.propTypes = {
  groupTitle: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
};

export default OptionalAddOnHeader;
